import { Col, Row } from "antd";
import React from "react";
import "./heroStructure.less";
interface TwoColStructureProps {
  right: React.ReactNode;
  left: React.ReactNode;
  imageLocation: "right" | "left";
  sectionProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  >;
}
const HeroStructure = (props: TwoColStructureProps) => {
  const { right, left, imageLocation, sectionProps } = props;
  return (
    <section id="HeroStructure" {...sectionProps}>
      <Row justify="center" align="middle" className="fRow">
        <Col xs={23} md={22} lg={21}>
          <Row justify="space-between" align="middle" gutter={[10, 50]}>
            <Col
              xs={24}
              lg={12}
              className={
                imageLocation == "left"
                  ? "HeroStructure-text"
                  : "HeroStructure-img"
              }
            >
              {right}
            </Col>
            <Col
              xs={24}
              lg={12}
              className={
                imageLocation == "right"
                  ? "HeroStructure-text"
                  : "HeroStructure-img"
              }
            >
              {left}
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default HeroStructure;
